import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Box, Button } from '@mui/material';
import ImageSelectorModal from './imageSelectorModal';

const ImageSelectorField = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const { setValue, getValues } = useFormContext();

  const handleSelect = (url) => {
    setImageUrl(url);
    setValue('image', url);
    setModalOpen(false);
  };

  return (
    <>
      <Box mt={2}>
        <Button variant="contained" onClick={() => setModalOpen(true)}>
          Seleccionar Imagen
        </Button>
        {imageUrl || getValues('image') ? (
          <Box mt={1}>
            <img src={imageUrl || getValues('image')} alt="Seleccionada" width="200" />
          </Box>
        ) : null}
      </Box>
      <ImageSelectorModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onSelect={handleSelect}
      />
    </>
  );
};

export default ImageSelectorField;
